define('settings',[
    'jquery',
    'server-settings'
    ],
    function ($, serverSettings) {
        var defaultSettings = {
            // Should preferably mimic the CSS breakpoints
            breakpoints: {
                medium: { min: 768, max: 0 },
                large: { min: 960, max: 0 },
                mlarge: { min: 1024, max: 0 },
                xlarge: { min: 1200, max: 0 },
                smallOnly: { min: 0, max: 768 },
                mediumOnly: { min: 768, max: 960 },
                largeOnly: { min: 960, max: 1200 }
            },
            transitionTime: 200,

            cachePriceTime: 5 * 60 * 1000, // 5 minutes
            logLevel: 'debug',
            filtersCategoriesName: 'categories',
            dateFormat: 'Y-m-d'
        };


        return  $.extend({}, defaultSettings, serverSettings);
    }
);
